module.exports = __webpack_public_path__ + "img/gen-onboard-wifi-activate.e457faaa.svg";